import { DependencyList, Dispatch, RefObject, SetStateAction, useEffect, useRef, useState } from 'react';

export const useSticky = (
    parentRef?: RefObject<HTMLDivElement> | null,
    updateDependency?: DependencyList,
): [boolean, Dispatch<SetStateAction<boolean>>, RefObject<HTMLDivElement> | null] => {
    const [isSticky, setIsSticky] = useState(false);
    const dummyRef = useRef<HTMLDivElement>(null);
    const stickyRef = parentRef ?? dummyRef;

    useEffect(() => {
        if (stickyRef.current === null) {
            return;
        }

        const observer = new IntersectionObserver(
            (elements) => {
                const isIntersecting = elements[0].intersectionRatio < 1;
                const isStickingFromTop = elements[0].boundingClientRect.top < 0;

                setIsSticky(isIntersecting && isStickingFromTop);
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: [1],
            },
        );

        observer.observe(stickyRef.current);
    }, [stickyRef, updateDependency]);

    return [isSticky, setIsSticky, stickyRef];
};
